<div class="card" #weeklySalesChart>
  <div class="border-b py-4 px-6 flex items-center">
    <h2 class="m-0 title flex-auto ">{{title}}</h2>
  </div>

  <div class="pt-3 pb-1 pr-6">
    <vex-chart [options]="options" [series]="series" [labels]="labels"></vex-chart>
  </div>
</div>
